<template>
  <div id="qr-code-scanner"></div>
</template>

<script>
import {Html5QrcodeScanner} from "html5-qrcode";

export default {
  name: 'QrCodeScanner',
  props: {
    qrbox: Number,
    fps: Number,
  },
  mounted: function () {
    let config = { fps: this.fps ? this.fps : 10 };

    if (this.qrbox) {
      config['qrbox'] = this.qrbox;
    }

    let html5QrcodeScanner = new Html5QrcodeScanner("qr-code-scanner", config);
    html5QrcodeScanner.render(this.onScanSuccess);
  },
  methods: {
    onScanSuccess(decodedText, decodedResult) {
      this.$emit('scan', decodedText, decodedResult);
    }
  }
};
</script>

<style>
#qr-code-scanner {
  border-radius: 12px;
}
#reader {
  border-radius: 12px;
}
#html5-qrcode-button-camera-start,
#html5-qrcode-button-camera-permission,
#html5-qrcode-button-file-selection,
#html5-qrcode-button-camera-stop {
  border: none;
  border-radius: 12px;
  background-color: var(--accent-color) !important;
  border-color: var(--accent-color) !important;
  color: var(--btn-color) !important;
  text-transform: uppercase;
  padding: 6px 18px;
  cursor: pointer;
}
#html5-qrcode-button-camera-start:hover,
#html5-qrcode-button-camera-permission:hover,
#html5-qrcode-button-file-selection:hover,
#html5-qrcode-button-camera-stop:hover {
  background-color: var(--btn-bg-darker) !important;
  border-color: var(--btn-bg-darker) !important;
}
#html5-qrcode-anchor-scan-type-change {
  display: block;
  margin-top: 10px;
}
#reader__scan_region video {
  border-radius: 12px 12px 0 0;
}
</style>